import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ActiviteDto } from "../../../../dto/GenApi.iNotPaie.Dto/ActiviteDto";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import $ from "jquery";
import moment from "moment";
import { NotificationServiceInstance } from "../../../../shared/services/notification.service";

@Component
export default class ModalCardActivity extends Vue {
	public estAjout = false;
	public activite?: ActiviteDto = undefined;
	public dateDebut?: string = "";
	public dateFin?: string = "";
	public titre?: string = "";
	public details?: string = "";
	public dataReady = true;
	public enableDateDebut = false;
	public enableDateFin = false;
	public enableFullPreview = false;
	public enableImportant = false;
	public isEdit = false;

	public init(isEdit: boolean, activite?: ActiviteDto): void {
		this.reset();

		this.isEdit = isEdit;
		this.activite = activite;

		this.estAjout = this.activite == undefined;
		this.titre = this.activite != undefined ? this.activite.Titre : "";
		this.details = this.activite != undefined ? this.activite.Details : "";

		this.dateDebut = this.activite != undefined && this.activite.Date != undefined ? moment.utc(this.activite.Date).format("YYYY-MM-DD") : "";
		this.dateFin = this.activite != undefined && this.activite.DateFin != undefined ? moment.utc(this.activite.DateFin).format("YYYY-MM-DD") : "";

		this.enableDateDebut = (this.dateDebut !== "");
		this.enableDateFin = (this.dateFin !== "");

		this.enableFullPreview = this.activite != undefined && this.activite.EstApercu != undefined ? this.activite.EstApercu : false;
		this.enableImportant = this.activite != undefined && this.activite.EstImportant != undefined ? this.activite.EstImportant : false;
	}

	public reset(): void {
		this.activite = undefined;
		this.titre = "";
		this.details = "";
		this.dateDebut = "";
		this.dateFin = "";

		this.enableDateDebut = false;
		this.enableDateFin = false;
		this.estAjout = false;
		this.isEdit = false;
		this.enableFullPreview = false;
		this.enableImportant = false;
	}

	public enregistrer(): void {
		this.dataReady = false;

		if (this.estAjout) {
			this.activite = { Id: 0 };

			this.setData();

			ServicesFactoryInstance.AccueilService.createActivite(this.activite, () => {
				this.afterSend(false);
			}, () => {
				NotificationServiceInstance.SendFailed("Erreur lors de la création de la note.");
				this.dataReady = true;
			});
		} else if (this.activite != undefined && !this.estAjout && this.isEdit) {
			this.setData();

			ServicesFactoryInstance.AccueilService.updateActivite(this.activite, () => {
				this.afterSend(true);
			}, () => {
				NotificationServiceInstance.SendFailed("Erreur lors de la mise à jour de la note.");
				this.dataReady = true;
			});
		} else {
			this.dataReady = true;
			$("#modalCardActivity").modal("hide");
		}
	}

	private setData(): void {
		if (this.activite !== undefined) {
			this.activite.Titre = this.titre;
			this.activite.Details = this.details;

			if (this.dateDebut != "" && this.enableDateDebut) {
				this.activite.Date = moment.utc(this.dateDebut).toDate();
			} else {
				this.activite.Date = undefined;
			}

			if (this.dateFin != "" && this.enableDateFin) {
				this.activite.DateFin = moment.utc(this.dateFin).toDate();
			} else {
				this.activite.DateFin = undefined;
			}

			this.activite.EstApercu = this.enableFullPreview;
			this.activite.EstImportant = this.enableImportant;
		}
	}

	private afterSend(isEdit: boolean): void {
		this.dataReady = true;
		this.$emit("updated");

		const message = (isEdit) ? "modifiée." : "ajoutée.";
		NotificationServiceInstance.SendSuccess("La note a bien été " + message);
		$("#modalCardActivity").modal("hide");
	}

	public annuler(): void {
		$("#modalCardActivity").modal("hide");
	}

	public getTitle(): string {
		let title;

		if (this.isEdit && !this.estAjout) {
			title = "Modifier";
		} else if (this.estAjout) {
			title = "Ajouter";
		} else {
			title = "Consulter";
		}

		return title + " une note";
	}
}



// WEBPACK FOOTER //
// ./src/components/home/modals/modalCardActivity/modalCardActivity.ts